<script>
import { mapGetters } from 'vuex'
import store from '../../store'
import PasswordChange from '@/views/user/PasswordChange.vue'
import { Icon } from 'ant-design-vue'
import NoticeIcon from '@/components/NoticeIcon'
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4657304_rc6g6vm9q7.js'
})
export default {
  name: 'UserInfo',
  components: {
    IconFont
  },
  methods: {
    ...mapGetters(['nickname', 'avatar', 'account', 'userInfo']),
    refreshUserInfo () {
      store.dispatch('GetInfo').then(() => {
        this.$message.success(this.$t('user.point.refresh.success'))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    changePassword () {
       this.showModal(PasswordChange, this.$t('user.account.password.change'), 600, 400)
    }
  }
}
</script>

<template>
  <div style="width: 100%;padding-top: 12px;">
    <div style="text-align: center;">
      <div> <a-avatar class="avatar" :size="64" :src="avatar()"/></div>
      <div style="margin-top: 8px;">{{ nickname() }}</div>
    </div>

    <div class="menu-list">
      <div class="menu-item" @click="changePassword">
        <div class="menu-icon">
          <a-icon type="safety-certificate" />
        </div>
        <div class="menu-label">{{ $t('user.account.password.change') }}</div>
      </div>
      <div class="menu-item">
        <div class="menu-icon">
          <a-icon type="google" />
        </div>
        <div class="menu-label">{{ $t('user.login.google.bind') }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="less"  scoped>
.menu-list{
  margin-top: 32px;
  .menu-item{
    line-height: 42px;
    padding: 0 8px;
    border-bottom: 1px solid #eaeaea;
    display: flex;
  }

  .menu-item:first-child{
    border-top: 1px solid #eaeaea;
  }

  .menu-item:hover{
    background-color: #F0F0F0;
    cursor: pointer;
  }

  .menu-label{
    margin-left: 6px;
  }

}
</style>
